import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsX } from "react-icons/bs";

const Popup = () => {
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(true);
  return (
    <>
      {toggle && (
        <div
          className="h-full w-full flex items-center justify-center bg-black bg-opacity-80
      fixed top-0 left-0 z-50"
        >
          <div
            className="flex bg-white_A700 rounded-3xl h-[70vh] w-[70vw] overflow-hidden relative
          md:flex-col sm:h-[80vh] sm:w-[80vw]"
          >
            <div className="w-full h-full popup-bg bg-center bg-no-repeat bg-cover"></div>
            <div
              className="w-full h-full flex items-center justify-center flex-col p-5 sm:h-[50%] sm:shrink-0
            gap-10 sm:gap-5"
            >
              <div className="bg-slate-300 w-20 h-20 rounded-full flex items-center justify-center shrink-0">
                <p className="text-[34px]">🎁</p>
              </div>
              <h2 className="font-bold text-black text-2xl text-center sm:text-lg">
                {t("giftText")}
              </h2>
            </div>
            <BsX
              className="absolute top-5 right-5 text-3xl cursor-pointer md:text-white"
              onClick={() => {
                setToggle(false);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
